export const SMS_VALIDATION_MESSAGES = {
  sms: {
    required: 'Udfyld venligst feltet',
    maxlength: 'Tekst må højst være 300 tegn',
  },
};
